import { render, staticRenderFns } from "./ResetPasswordRequestSentView.vue?vue&type=template&id=9bf40a9e&"
import script from "./ResetPasswordRequestSentView.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequestSentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports